import { Loader2 } from 'lucide-react'

interface RefreshButtonProps {
    isLoading: boolean
    onClick: () => void
    disabled?: boolean
}

interface RefreshIconProps {
    onClick: () => void
    disabled?: boolean
}

function RefreshButton({ isLoading, onClick, disabled = false }: RefreshButtonProps) {
    if (disabled) return <RefreshIcon onClick={onClick} disabled={disabled} />
    if (isLoading) return <Loader2 className='text-mach-accent-foreground h-4 w-4 animate-spin' />
    return <RefreshIcon onClick={onClick} disabled={disabled} />
}

const RefreshIcon = ({ onClick, disabled = false }: RefreshIconProps) => {
    return (
        <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='cursor-pointer text-white transition-all hover:text-white hover:opacity-80'
            onClick={disabled ? undefined : onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.27272 6.99998C1.27272 3.8369 3.8369 1.27272 6.99998 1.27272C8.98496 1.27272 10.7351 2.28262 11.763 3.81823H10.1818C9.83038 3.81823 9.54547 4.10314 9.54547 4.45459C9.54547 4.80604 9.83038 5.09095 10.1818 5.09095H12.8229C12.8306 5.09109 12.8382 5.09109 12.8459 5.09095H12.9818C13.5442 5.09095 14 4.63508 14 4.07277V1.27278C14 0.921327 13.7151 0.636419 13.3636 0.636419C13.0122 0.636419 12.7273 0.921327 12.7273 1.27278V2.97454C11.4609 1.17605 9.36825 0 6.99998 0C3.134 0 0 3.134 0 6.99998C0 10.8659 3.13399 14 6.99998 14C10.5096 14 13.4151 11.4176 13.9218 8.04919C13.9741 7.70165 13.7347 7.37753 13.3872 7.32524C13.0396 7.27296 12.7155 7.51231 12.6632 7.85986C12.2488 10.6149 9.87048 12.7272 6.99998 12.7272C3.8369 12.7272 1.27272 10.163 1.27272 6.99998Z'
                fill='white'
            />
        </svg>
    )
}

export default RefreshButton
